import { gql } from '../generated'

gql(/* GraphQL */ `
  fragment PricebookItem on PricebookItems {
    description
    isActive
    isDeleted
    isDiscountable
    isTaxable
    itemType
    name
    priceUsd
    costUsd
    pricebookItemCode
    pricebookItemGuid
    version
    basePriceUsc
    memberPriceUsc
    memberAddonPriceUsc
    memberAfterhoursPriceUsc
    memberAddonAfterhoursPriceUsc
    addonPriceUsc
    addonAfterhoursPriceUsc
    afterhoursPriceUsc

    photo {
      cdnUrl
      photoGuid
    }
  }
`)

export const GET_PRICEBOOK_DATA = gql(/* GraphQL */ `
  query GetPricebookData {
    pricebookCategories {
      pricebookItems(
        where: { isDeleted: { _eq: false }, isActive: { _eq: true } }
      ) {
        ...PricebookItem
      }
      name
      pricebookCategoryGuid
      parentCategoryGuid
      photo {
        cdnUrl
        photoGuid
      }
    }
    uncategorizedItems: pricebookItems(
      where: {
        pricebookCategoryGuid: { _isNull: true }
        isDeleted: { _eq: false }
        isActive: { _eq: true }
      }
    ) {
      ...PricebookItem
    }
  }
`)

export const GET_RECENT_PRICEBOOK_ITEMS = gql(/* GraphQL */ `
  query GetRecentPricebookItems($userGuid: uuid!, $limit: Int!) {
    recentPricebookItems(
      where: { userGuid: { _eq: $userGuid } }
      limit: $limit
      orderBy: { lastViewedAt: DESC }
    ) {
      pricebookItemGuid
    }
  }
`)

export const GET_FAVORITE_PRICEBOOK_ITEMS = gql(/* GraphQL */ `
  query GetFavoritePricebookItems($userGuid: uuid!, $limit: Int!) {
    favoritePricebookItems(
      where: { userGuid: { _eq: $userGuid } }
      limit: $limit
      orderBy: { createdAt: DESC }
    ) {
      pricebookItemGuid
    }
  }
`)

export const INSERT_FAVORITE_PRICEBOOK_ITEM = gql(/* GraphQL */ `
  mutation InsertFavoritePricebookItem(
    $object: FavoritePricebookItemsInsertInput!
  ) {
    insertFavoritePricebookItemsOne(object: $object) {
      pricebookItemGuid
    }
  }
`)

export const DELETE_FAVORITE_PRICEBOOK_ITEM = gql(/* GraphQL */ `
  mutation DeleteFavoritePricebookItem(
    $pricebookItemGuid: uuid!
    $userGuid: uuid!
  ) {
    deleteFavoritePricebookItemsByPk(
      pricebookItemGuid: $pricebookItemGuid
      userGuid: $userGuid
    ) {
      pricebookItemGuid
    }
  }
`)
